import React from 'react'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useTableContext } from '@/components/report-tables/editable/editableTableContext'

const TableStatusIndicator = React.memo(function TableStatusIndicator () {
  const { activeEditor, sourceDataSaving, sourceDataSavingError } = useTableContext().state

  if (activeEditor) {
    return <Icon name='edit' />
  }

  if (sourceDataSavingError) {
    return <Resx render={({ localize }) =>
      <Icon name='x' title={localize('Reporting.SynchronizationError')} />}
    />
  }

  return sourceDataSaving ? <LoadingIndicator inline /> : <Resx render={({ localize }) =>
    <Icon name='check' title={localize('Reporting.DataSynchronized')} />}
  />
})

export { TableStatusIndicator }



// WEBPACK FOOTER //
// ./src/components/reporting/tableStatusIndicator.js